import { render, staticRenderFns } from "./Tech.vue?vue&type=template&id=312457bc"
import script from "./Tech.vue?vue&type=script&lang=ts"
export * from "./Tech.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports